import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Collapse from "@mui/material/Collapse";
import { useAccountMode } from "../utils/accountMode";
// import { TypeAnimation } from 'react-type-animation';

export default function ScopeHeader({
  bgImage,
  bgColor,
  linearGradient,
  txtColor,
  title,
  description,
  id,
  dataTestId,
  width,
  contentColor,
  bgPosition,
  bgSize,
  bgRepeat,
  height,
  showCloseIcon = false,
}) {
  const [isVisible, setIsVisible] = useState(false);

    const { isFette, prefixPath } = useAccountMode();

  useEffect(() => {
    setIsVisible(true);

    return () => {
      setIsVisible(false);
    };
  }, []);

  return (
    <Collapse in={isVisible} timeout={500}>
      <div
        className="bannerWrapper"
        style={{
          width: width || "100%",
          height: height || "207px",

          background: `url(${bgImage}) , 
        linear-gradient(0deg, ${ isFette ? "rgba(0,0,0,0.65)" : bgColor})`,
        //   backgroundColor: bgColor,
          color: txtColor,

          backgroundPosition: bgPosition,
          backgroundSize: bgSize,
          backgroundRepeat: bgRepeat

        }}
        id={id}
        data-testid={dataTestId}
      >
        {showCloseIcon ? (
          <CloseIcon
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              fontSize: 20,
              color: "rgba(255,255,255,0.9)",
            }}
          />
        ) : null}
        <div
          className="title"
          style={{ color: contentColor ? contentColor : "inherit" }}
        >
          {title}
        </div>
        <div
          className="description"
          style={{ color: contentColor ? contentColor : "inherit" }}
        >
          {/* <TypeAnimation
                        sequence={[
                            description,
                            1000,
                        ]}
                        speed={80}
                    /> */}
          {description}
        </div>
      </div>
    </Collapse>
  );
}
